<template>
  <main class="main page-inside rules-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="title weight-600">{{ $t("Rules") }}</div>
            </div>
          </div>

          <div class="categories">
            <transition name="fade">
              <div class="list">
                <div class="item">
                  <div class="item-wrapper">
                    <button
                      :class="['desc small', { active: theme == 1 }]"
                      @click="changeTheme(1)"
                    >
                      <b>{{ $t("Server Rules") }}</b>
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <div class="section rules-section">
        <div class="wrapper rules-wrapper" v-if="theme == 1">
          <div class="title title-main weight-600">
            {{ $t("Server rules") }}
          </div>

          <div class="item">
            <div class="title medium">{{ $t("1. Griefing and Raiding:") }}</div>
            <div class="desc small">
              {{
                $t(
                  "Destroying or looting other players' claims, towns, or islands is strictly forbidden."
                )
              }}
            </div>
          </div>

          <div class="item">
            <div class="title medium">{{ $t("2. Scamming:") }}</div>
            <div class="desc small">
              {{
                $t(
                  "Deceptive practices or scamming other players are not allowed under any circumstances."
                )
              }}
            </div>
          </div>

          <div class="item">
            <div class="title medium">{{ $t("3. TP Killing:") }}</div>
            <div class="desc small">
              {{
                $t(
                  "Using teleportation commands or mechanics to ambush or kill another player without warning or agreement is prohibited."
                )
              }}
            </div>
          </div>

          <div class="item">
            <div class="title medium">
              {{ $t("4. Claim Camping and Killing:") }}
            </div>
            <div class="desc small">
              <ul>
                <li>
                  {{
                    $t(
                      "a) Claim Camping: Remaining in another player's claim with the intent to disturb their gameplay is not permitted."
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      "b) Claim Killing: Exploiting the safety of your own claimed land to unfairly attack others is not allowed."
                    )
                  }}
                </li>
              </ul>
            </div>
          </div>

          <div class="item">
            <div class="title medium">{{ $t("5. Insiding:") }}</div>
            <div class="desc small">
              {{
                $t(
                  "Stealing from group projects and subsequently leaving or griefing is prohibited."
                )
              }}
            </div>
            <div class="desc small">
              <ul>
                <li>
                  {{
                    $t(
                      "a) Players leaving a group (island, town, or clan) are entitled to items they contributed, within reason. These items must be returned promptly."
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      "b) If disputes arise, players must first attempt to resolve the issue independently. If no resolution is reached, staff assistance may be requested via a support ticket. Staff intervention may result in penalties for group leaders who do not comply with this rule."
                    )
                  }}
                </li>
              </ul>
            </div>
          </div>

          <div class="item">
            <div class="title medium">{{ $t("6. Claiming Rules:") }}</div>
            <div class="desc small">
              <ul>
                <li>
                  {{
                    $t(
                      "a) Claiming land or creating a protected area within 16 blocks of another claim or town is forbidden."
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      "b) Using ender pearls to bypass claim protections or access restricted areas is not allowed."
                    )
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Rules",
  props: [],
  components: {},
  data: function () {
    return {
      theme: 1,
    };
  },
  mounted() {},
  methods: {
    changeTheme(theme) {
      this.theme = theme;
    },
  },
};
</script>
